import { Item } from '@/api/items/items.types';
import Card from '@components/base/card/card.component';
import { DataGridPremium } from '@mui/x-data-grid-premium';
import { deDE, enUS } from '@mui/x-data-grid-premium/locales';
import { memo, useMemo } from 'react';
import { useItemsDataHook } from '../hooks/use-items-data.hook.ts';
import { useItemsGridColumns } from '../hooks/use-items-grid-columns.hook.tsx';
import { ItemsGridFooter } from './items-grid-footer.tsx';
import { useTranslation } from 'react-i18next';

export const ItemsGrid = memo(function ItemsGrid({
  items,
  isLoading,
}: {
  items: Item[];
  isLoading: boolean;
}) {
  const { i18n } = useTranslation();
  const { uniqueItemGroups, uniqueManufacturers } = useItemsDataHook();
  const columns = useItemsGridColumns(uniqueItemGroups, uniqueManufacturers);

  const gridLocale = useMemo(() => {
    return i18n.language === 'de'
      ? deDE.components.MuiDataGrid.defaultProps.localeText
      : enUS.components.MuiDataGrid.defaultProps.localeText;
  }, [i18n.language]);

  return (
    <Card
      elevation={2}
      sx={{
        height: '100%',
        backgroundColor: 'white',
        flexGrow: 1,
        width: 'auto',
      }}
    >
          <DataGridPremium
            rows={items}
            columns={columns}
            loading={isLoading}
            localeText={gridLocale}
            pagination={false}
            disableColumnSorting
            disableColumnFilter
            slots={{
              footer: ItemsGridFooter,
            }}
            getRowId={(x) => x.id}
            rowSelection={false}
            cellSelection={false}
            rowBufferPx={900}
            sx={{
              '& .MuiDataGrid-cell': {
                padding: '0 4px',
              },
            }}
            initialState={{
              columns: {
                columnVisibilityModel: {
                  itemGroup: false,
                  manufacturer: false,
                },
              },
              pinnedColumns: {
                right: ['cartQuantity', 'actions'],
              },
            }}
          />
    </Card>
  );
});
